import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const TableContainer = styled.div`
  width: 100%;
  height: 200px;
  overflow-y: scroll;
`;

export const TrHead = styled.tr`
  background-color: ${ColorSF2.white};
  display: flex;
  justify-content: end;
  height: 32px;
  border-top: 1px solid ${ColorSF2.mediumGray};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
